<template>
    <div
        :style="cardStyle"
        class="redesign-base-card"
        data-testid="base-card"
        :class="{
            'redesign-base-card--with-border': withBorder,
            'redesign-base-card--no-animation': isVisualAlertDisabled || disableAnimation
        }"
    >
        <slot name="content" />
    </div>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue'
import { isVisualAlertDisabled } from '@/composables/globalData/useLayouts'

const hexOpacity = '66'


const props = withDefaults(
    defineProps<{
        shadow?: string
        withBorder?: boolean
        borderColor?: string
        borderWidth?: number | string
        disableAnimation?: boolean
    }>(),
    {
        shadow: '',
        withBorder: true,
        borderColor: '',
        borderWidth: 1,
        disableAnimation: false
    }
)


const { shadow } = toRefs(props)

const borderWidthValue = computed(() => {
    const width = props.borderWidth
    return typeof width === 'number' ? `${width}px` : width
})

const cardStyle = computed(() => ({
    '--shadow-color': shadow.value,
    '--animated-shadow-color': shadow.value + hexOpacity,
    '--card-border-color': props.borderColor || 'var(--colorWidgetBorder-color)',
    '--card-border-width': borderWidthValue.value
}))
</script>

<style scoped lang="scss">
.redesign-base-card {
    border-radius: 8px;
    overflow: hidden;
    animation: blink-shadow 2s infinite;
    &--with-border {
      border: var(--card-border-width, 1px) solid var(--card-border-color);
    }
    &--no-animation {
      animation: none;
      box-shadow: 0 0 9px 0 var(--shadow-color);
    }
}

@keyframes blink-shadow {
    0% {
        box-shadow: 0 0 9px 0 var(--shadow-color);
    }
    50% {
        box-shadow: 0 0 11px 0 var(--animated-shadow-color);
    }
    100% {
        box-shadow: 0 0 9px 0 var(--shadow-color);
    }
}
</style>
